<!-- Manage users / invite users to a project -->

<div class="row justify-content-center m-0">
    <div class="col-lg-10" style="margin-top:15px;">

        <app-quick-guides *ngIf="permissions?.can?.show_intro_tour?.site_settings && (uiManager.toggleQuickGuide$ | async)?.screen == 'users' && (uiManager.toggleQuickGuide$ | async)?.show" [context]="this" guidesMode="users"></app-quick-guides>

        <!-- Manage users heading -->
        <mat-tab-group>
            <mat-tab [label]="'NAV.MENU_USER_ADMIN' | translate"> 

                <!-- Invite new user button -->
                <button mat-raised-button color="primary" id="manage-users" class="mt-3"
                (click)="inviteUser()" id="invite-new" >{{ 'USER_ADMIN.INVITE_BTN' | translate }}</button>

                <!-- Quick guides button -->
                <button mat-icon-button matTooltip="{{ 'NAV.QUICK_GUIDES' | translate }}" class="fdm-linked" (click)="uiManager.toggleQuickGuidePopup('users', true)">
					<fa-icon icon="question-circle"></fa-icon>
				</button>

                <div class="p-3">
                    <div class="row">
            
                    <!-- <textarea style="width:90%;height:140px;font-size:10px;">{{ permissions.roleActual | json }}</textarea> -->
                    <div class="col-5" style="border-right:solid 2px rgb(228, 228, 228);">
                        <table class="fdm-sidebar-table-list">
                            
                            <tr>
                                <!-- Name -->
                                <th>{{ 'USER_ADMIN.NAME' | translate }}</th>
                                                            
                                <!-- Date user created -->
                                <th>{{ 'GENERIC.CREATED' | translate }}</th>

                            </tr>

                            <!-- Invited users pending accept -->
                            <tr *ngFor="let user of userList|async; let idx = index" [ngClass]="{'fdm-sidebar-selected':curUser == user} " (click)="curUser = user">
                                <td class="fdm-linked">
                                    {{ user.user.name }}
                                    <span *ngIf="service.myProfile.id == user.user.id" class="badge badge-info">{{ 'GENERIC.YOU' | translate }}</span>
                                    <span *ngIf="!user.user.active && !user.isInvite" class="badge badge-warning">{{ 'GENERIC.INACTIVE' | translate }}</span>
                                    <span *ngIf="user.isInvite" class="badge badge-primary">{{ 'GENERIC.INACTIVE' | translate }}</span>

                                    <!-- functionality to save rules for each user on an account forthcoming ... don't delete 
                                    <div *ngIf="permissions.roleSelected == 'domain_admin'">
                                        <textarea style="width:100%;height:80px;font-size:9px;">{{ fourD?.account?.__acl_users[user.id] | json }}</textarea>
                                        <button (click)="saveUserRules(user.id)">save</button>
                                    </div>
                                    -->
                                </td>
                                
                                <td> {{ user.user.dateMade | dateAgo | async }} </td>
                            </tr>

                        </table>
                    </div>
                    <div class="col-7">
                        <div class="alert" style="color:#888;" *ngIf="!curUser">{{ 'USER_ADMIN.SELECT_USER' | translate }}</div>
                        <userdetails-comp [userStub]="curUser"></userdetails-comp>
                    </div>
                </div></div>
            
            </mat-tab>

            <!-- <mat-tab label="Manage Roles and Access" *ngIf="true && ( permissions.roleSelected == 'domain_admin' || permissions.roleSelected == 'account_admin' )">  -->
            
            <!-- Manage roles and access ; set to 'false' in the test to hide it for now -->
            <mat-tab *ngIf="permissions?.can?.manage_users && false" label="{{ 'SETTINGS.ROLES' | translate }}"> 

                <!-- <textarea style="width:100%;height:170px;font-size:10px;">{{ userRoles | json }}</textarea>
                <textarea style="width:100%;height:170px;font-size:10px;">{{ roles | json }}</textarea> -->

                <!-- Set role and access -->
                <div style="margin:30px 0;background-color:#eee;border-radius:10px;padding:10px 0 0 12px;">                  
                        <mat-label>{{ 'SETTINGS.ACCESS_RULES' | translate }}</mat-label>
                        <mat-radio-group [(ngModel)]="viewRole" aria-label="Select an option">
                            <mat-radio-button *ngFor="let role of roles" style="margin-left:15px;" [value]="role.id" (change)="viewRoleAccess($event)">{{ role.name }}</mat-radio-button>
                        </mat-radio-group>              
                </div>

                <!-- <textarea style="width:90%;height:270px;font-size:10px;">{{ resources | json }}</textarea> -->

                <table style="width:100%;">
                    <ng-container *ngFor="let res of viewRoleResources | keyvalue: keyOrderNone">         
                        <tr>
                            <th style="font-size:12px;color:lightslategrey;border-bottom:solid 1px #eee;">
                                {{ res.key  }}
                            </th>
                        </tr>
                        <tr>
                            <td style="vertical-align:top;text-align:left;" style="margin-right:1px;">
                                <mat-grid-list cols="6" gutterSize="0" rowHeight="40px">
                                    <mat-grid-tile *ngFor="let fea of res.value | keyvalue: keyOrderNone" style="font-size:12px;text-align:left;vertical-align:top;">

                                        <mat-checkbox [(ngModel)]="fea.value"> {{ fea.key  }} </mat-checkbox>

                                        <!-- <table style="width:100%;margin-right:8px;padding-right:8px;border-right:2px #aaa;">
                                            <tr>
                                                <td style="font-size:10px;vertical-align:top;text-align:left;">
                                                    <mat-checkbox [(ngModel)]="fea.value"> {{ fea.key  }} </mat-checkbox>
                                                </td>
                                                <td style="width:80px;font-size:14px;vertical-align:top;text-align:right;">
                                                    <div *ngIf="fea.value">
                                                        <fa-icon icon="times" class="fdm-icon" style="color:gray;margin-left:4px;"></fa-icon>
                                                        <fa-icon icon="eye-slash" class="fdm-icon" style="color:gray;margin-left:4px;"></fa-icon>
                                                        <fa-icon icon="eye-slash" class="fdm-icon" style="color:gray;margin-left:4px;"></fa-icon>
                                                        <fa-icon icon="eye" class="fdm-icon fdm-icon-selected" style="margin-left:4px;"></fa-icon>
                                                    </div>
                                                    

                                                    !-- <select *ngIf="fea.value" value="hide" style="width:auto;">
                                                        <option *ngFor="let value of ['hide','promote_plan','promote_role','show']" [value]="value">{{ value }}</option>
                                                    </select> --
                                                </td>
                                            </tr>
                                        </table> -->

                                    </mat-grid-tile>
                                </mat-grid-list>
                            </td>
                        </tr>
                        <tr>
                            <th style="background-color:#fff;height:20px;">
                                
                            </th>
                        </tr>
                    </ng-container>
                </table>
            </mat-tab>

        </mat-tab-group>

        <!--
        <mat-card  class="mt-3 mb-4 noshow">
	  
            <mat-card-content>

                <mat-list>
                    <mat-list-item>
                        <div class="row m-0 w-100">
                            <div class="col-3">
                                <h5 class="mb-0" translate="">USER_ADMIN.NAME</h5>
                            </div>
                            <div class="col-5">
                                <div class="row m-0">
                                    <div class="col-3" *ngFor="let group of groups"><h5 class="mb-0 align-text-center">{{ 'USER_ADMIN.' + service.getAccessGroupSufix(group.uid, fourD.activeTeam.uid) | translate }}</h5></div>
                                </div>
                            </div>
                        <div class="col-2">
                            <h5 class="mb-0" translate="">USER_ADMIN.SHARED_PROJECT</h5>
                        </div>
                        <div class="col-2">
                            <h5 class="mb-0" translate="">USER_ADMIN.DELETE_USER</h5>
                        </div>
                        </div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <ng-container *ngFor="let user of users">
                        <mat-list-item style="height: fit-content !important;">
                            <div class="row m-0 w-100">
                                <div class="mt-3  col-3">
                                    <p class="mb-0">
                                        {{user.name}}
                                        !-- <textarea style="height:100px;font-size:9px;width:100%;">{{ user | json }}</textarea> --
                                        !--
                                        <mat-chip *ngIf="service.myProfile.id == user.id" color="primary" selected class="p-1 user-chip">{{ 'GENERIC.YOU' | translate }}</mat-chip>
                                        --
                                        <span *ngIf="service.myProfile.id == user.id" class="badge badge-info">{{ 'GENERIC.YOU' | translate }}</span>
                                        <span *ngIf="!user.active" class="badge badge-warning">{{ 'GENERIC.INACTIVE' | translate }}</span>
                                    </p>
                                </div>
                                <div class="mt-3  col-5">

                                    <div class="row m-0">
                                    <div class="col-1"></div>
                                        <div class="col-3" *ngFor="let group of groups">
                                            <mat-checkbox
                                                #groupCheck
                                                class="mb-0 group-check"
                                                [checked]="isUserOnGroup(user, group)"
                                                [disabled]="isUserOnAdminGroup(user) && isAdminGroup(group) && service.myProfile.id == user.id"
                                                (click)="changeAccessValidation(groupCheck, user, group)"
                                                (change)="changeUserAccess($event, user, group)">
                                            </mat-checkbox>
                                        
                                        </div>
                                    </div>

                                </div>
                            <div class="col-2">
                                !--<span *ngFor="let p of user['projects']">
                                {{p.name}}
                                </span>--
                                    <button mat-icon-button [disabled]="isUserOnAdminGroup(user)" (click)="shareProject(user)"><fa-icon icon="share-alt"></fa-icon></button>
                            </div>
                            <div class="col-2">
                                <button mat-icon-button [disabled]="service.myProfile.id == user.id" (click)="deleteUser(user)"><fa-icon icon="trash"></fa-icon></button>
                            </div>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                    </ng-container>

                </mat-list>

                !--
                <mat-tab-group>
                    <mat-tab *ngFor="let cur of groups" [label]="cur.name">
                        <div class="p-4">
                            <div class="row">
                                <div class="col-6">
                                  <mat-form-field>
                                    <input type="text" matInput [(ngModel)]="cur.name" [placeholder]="'SETTINGS.GROUP_NAME' | translate" (blur)="cur.save()"/>
                                  </mat-form-field>
                                </div>
                                <div class="col-5">
                                    <div qmap-question [qMap]="{type:'object',obj_type:'User',title:'SETTINGS.ADD_USER' | translate}" (qmap-change)="addUser(cur,$event)"></div>
                                </div>
                                <div class="col-1 text-right">
                                    <button mat-icon-button (click)="newUser(cur)"><fa-icon icon="plus"></fa-icon></button>
                                </div>
                            </div>

                           <div [vlist]="cur.users"></div>
                       </div>
                    </mat-tab>
                </mat-tab-group>
            --
            </mat-card-content>
        </mat-card>
-->

</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
